import React from 'react';
import './About.css';

const credentials = [
  'Six Sigma Certified — Process Excellence',
  'General Management — Strategic Alliances & BD',
  'Mumbai University — Graduate Education',
];

const About = () => (
  <section id="about" className="sec">
    <div className="w">
      <div className="ag">
        <div className="rv">
          <div className="eye">About StratX</div>
          <h2 className="sh">Strategy That <span>Moves You</span> Forward</h2>
          <div className="at">
            <p>
              StratX is a corporate strategy and business development consulting firm that helps companies grow faster, smarter, and sustainably. With deep roots in multinational corporations and cross-border market development, we bring institutional rigour to every engagement.
            </p>
            <p>
              We work with 50+ companies across national and international markets — guiding everything from market entry and startup strategy to value proposition design, customer development, and the international expansion of Indian companies into the Middle East and Africa.
            </p>
          </div>
          <div className="acrd">
            {credentials.map((cred) => (
              <div className="crd" key={cred}>
                <div className="crdi">
                  <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="#1D4ED8" strokeWidth="1.5">
                    <path d="M4 8l3 3 5-5" />
                  </svg>
                </div>
                {cred}
              </div>
            ))}
          </div>
        </div>
        <div className="rv d2">
          <div className="acs">
            <div className="ac ac1">
              <div className="acl">Track Record</div>
              <div className="acv"><span>50</span>+</div>
              <div className="acd">Companies served across national &amp; international markets</div>
              <div className="acli">
                <div className="aclii">India &amp; South Asia</div>
                <div className="aclii">UAE &amp; Middle East</div>
                <div className="aclii">Africa</div>
              </div>
            </div>
            <div className="ac ac2">
              <div className="acl">Experience</div>
              <div className="acv"><span>15</span>+</div>
              <div className="acd">Years in MNC leadership, strategy &amp; business development</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default About;
